/**
 * Overrides the default BrowserRouter getUserConfirmation.
 * Useful for displaying a custom UI during page transition.
 * @param dialogKey - Unique generated dialog key for the transition. Passed as "message" to Prompt component.
 * @param {fn} callback - Function to execute once the dialog is closed
 */
export const getUserConfirmation = (dialogKey, callback) => {
    // Retrieve the Symbol registered with the given key
    // dialogTrigger is a function
    const dialogTrigger = window[Symbol.for(dialogKey)];
    if (dialogTrigger) {
        return dialogTrigger(callback);
    }
    // Fallback to default
    return callback(true);
};
